<template>
  <app-modal
    modal-alignment="top"
    modal-id="link-modal"
    modal-size="large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ selectedUrl ? $t("edit") : $t("add") }}</h5>
      <button
        aria-label="Close"
        class="close outline-none"
        data-dismiss="modal"
        type="button"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <app-overlay-loader v-if="preloader" />
    <template slot="body">
      
      <form
        ref="form"
        :class="{ 'loading-opacity': preloader }"
        :data-url="selectedUrl ? selectedUrl : LINKS"
      >
        <div class="form-group">
          <label>{{ $t("services") }}<span class="text-danger">*</span></label>
          <app-input
            type="multi-select"
            v-model="selectedServices"
            :list="services"
            list-value-field="name"
          />
        </div>

        <div v-if="customErrorMessage" class="mb-3">
          <span class="text-danger">{{ customErrorMessage }}</span>
        </div>
      </form>
    </template>
    <template slot="footer">
      <button
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        type="button"
        @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <app-submit-button
        @click="submit"
        :loading="loading"
        :disabled="!selectedServices.length"
      />
    </template>
  </app-modal>
</template>

<script>
import { urlGenerator } from "../../../../Helpers/AxiosHelper";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { LINKS } from "../../../../Config/ApiUrl";

export default {
  name: "LinkModal",
  mixins: [FormMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    services: Array,
  },
  data() {
    return {
      urlGenerator,
      LINKS,
      errors: [],
      loading: false,
      preloader: false,
      customErrorMessage: "",
      selectedServices: [],
      link: {},
    };
  },
  methods: {
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
      this.link.services = this.selectedServices;
      this.save(this.link);
    },
    async beforeGetEditData() {
      this.preloader = true;
    },
    afterSuccessFromGetEditData({ data }) {
      this.loading = false;
      this.preloader = false;
      this.link = { ...data };
      this.selectedServices = data.services
        ?.filter((service) => this.services.find((s) => s.id === service?.id))
        .map((service) => service?.id);
    },
    afterError(response) {
      this.loading = false;
      this.preloader = false;
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.closeModal();
    },
    sanitizeMetaData(value) {
      let meta = value
        .split(",")
        .map((el) => {
          return el.trim();
        })
        .join();
      return meta;
    },
    closeModal(value) {
      this.$emit("close-modal", value);
    },
  },
  mounted() {
    this.$store.dispatch("getCustomFieldType");
  },
};
</script>
